import __ from "web/Layout/Translations";

type MenuNode = {
  label?: string | null;
  items?: MenuNode[];
};

const translateMenuLabels = <T extends MenuNode>(items: T[]): T[] =>
  items.map((item) => ({
    ...item,
    ...(item.label ? { label: __(item.label) } : {}),
    ...(item.items ? { items: translateMenuLabels(item.items) } : {}),
  }));

export default translateMenuLabels;
